import { FilterModel } from '@hooks/useFiltersSearchParams';

export const buildFilterObject = (filters: FilterModel[]): Record<string, any> => {
  const result: Record<string, any> = {};
  const validFilters: FilterModel[] = filters.filter((item: FilterModel) =>
      typeof item.value === 'string'
          ? item.value.trim().length > 0
          : Array.isArray(item.value) && item.value.some((str: string) => str.trim().length > 0)
  );
  for (const filter of validFilters) {
    if (filter.name === 'dateRange') {
      const values = Array.isArray(filter.value) ? filter.value : [filter.value];
      if (filter.fieldNames?.length) {
        filter.fieldNames.forEach((field, index) => {
          result[field] = values[index] ?? null;
        });
      } else {
        result['startDate'] = values[0] ?? null;
        result['endDate'] = values[1] ?? null;
      }
    } else if (filter.name === 'trackOrExternalNumbers') {
      result[filter.name] = filter.value[0].split(',').map((value: string) => value.trim());
    } else {
      result[filter.name] = filter.value;
    }
  }
  return result;
};